/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

///////////////////////////////////////////////////////////
/////////////////// BAND MATH /////////////////////////////
///////////////////////////////////////////////////////////

import * as Blockly from 'blockly/core';
import 'blockly/python';

/////////////////////////////////////////////////////////
/////////////////// EXPRESSION //////////////////////////
/////////////////////////////////////////////////////////

Blockly.Blocks['analyse_math_arithmetic_overriden'] = {
    init: function () {
        var OPERATORS =
            [[Blockly.Msg.MATH_ADDITION_SYMBOL, 'ADD'],
            [Blockly.Msg.MATH_SUBTRACTION_SYMBOL, 'MINUS'],
            [Blockly.Msg.MATH_MULTIPLICATION_SYMBOL, 'MULTIPLY'],
            [Blockly.Msg.MATH_DIVISION_SYMBOL, 'DIVIDE'],
            [Blockly.Msg.MATH_POWER_SYMBOL, 'POWER']];
        this.setHelpUrl(Blockly.Msg.MATH_ARITHMETIC_HELPURL);
        this.setStyle('bandMath');
        this.setOutput(true, 'band_math_expression');
        this.appendValueInput('A')
            .setCheck('band_math_expression');
        this.appendValueInput('B')
            .setCheck('band_math_expression')
            .appendField(new Blockly.FieldDropdown(OPERATORS), 'OP');
        this.setInputsInline(true);
    }
};